import { Component, OnInit } from '@angular/core';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { RequestService } from 'src/app/services/requests.service';
import { ActivatedRoute } from '@angular/router';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-samples',
  templateUrl: './samples.component.html',
  styleUrls: ['./samples.component.scss']
})
export class SamplesComponent implements OnInit {

  public id = history.state.id;

  public gridApi: any;
  public gridColumnApi: any;
  public rowData: any[];
  public defaultColDef: ColDef = {
    flex: 0,
    sortable: true,
    filter: true,
    resizable: true,
    filterParams: {
      buttons: ['reset', 'apply'],
      filterOptions: ["contains", "notContains"]
    },
  }

  public gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'single',
  }

  public columnDefs: ColDef[] = [
    { field: 'compendium_id', headerName: "Data Entry", width: 100 },
    { field: 'stage', headerName: "Sampling site/stage" },
    { field: 'product_type', headerName: "Type of Product" },
    { field: 'sample_size', headerName: "Sample size (g)" },
    { field: 'shiga_toxin', headerName: "Shiga Toxin" },
    { field: 'batch', headerName: "Batch" },
    { field: 'positive_ecoli', headerName: "Positive Sampes for E.coli" },
    { field: 'samples_num', headerName: "Number of Samples, N" },
    { field: 'prevalence', headerName: "Prevalence (%)" },
    { field: 'detection_method', headerName: "Detection Method" },
    { field: 'con_expression', headerName: "Concentration Expression" },
    { field: 'con_results', headerName: "Concentration Results" },
    { field: 'doi', headerName: "DOI" },
    { field: 'additional_info', headerName: "Additional Info" },

  ];

  constructor(private req: RequestService<any>, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.id = history.state.id || this.route.snapshot.paramMap.get('id');
    this.req.getLiteratureSamples(this.id).subscribe((res) => {
      this.rowData = res;
    })
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  downloadFile() {
    const worksheetData = this.rowData.map(row => {
      const rowData = {};
      this.columnDefs.forEach(col => {
        rowData[col.headerName] = row[col.field];
      });
      return rowData;
    });
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create workbook and add worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Samples');

    // Convert workbook to blob
    const workbookBlob = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([workbookBlob], { type: 'application/octet-stream' });

    // Trigger download
    saveAs(blob, `samples_${this.id}.xlsx`);

  }
}
